<script>
    import { onMount } from "svelte";
    import { handleTokenAuthorization, redirectToLoginPage } from "./auth.js";
    import { initSentry } from "./sentryIntegraction.js"
    import Navbar from "./Components/Navbar.svelte";
    import WorkContainer from "./Components/WorkContainer.svelte";

    let displayContent = false;

    onMount(async () => {
        initSentry();
        handleTokenAuthorization()
            .then(() => {
                displayContent = true;
            })
            .catch(() => {
                redirectToLoginPage();
                displayContent = false;
            });
    });
</script>

{#if displayContent}
    <Navbar />
    <main class="workspace">
        <WorkContainer />
    </main>
{/if}
